import AnimatedPortal from 'mz-ui-kit/core/AnimatedPortal'
import React from 'react';

const RenderPortal = ({ children }) => (
  <AnimatedPortal
    render={() => children}
    duration={0}
    showed
  />
)

export default RenderPortal;
